/**
 * An instance of WS.WhiteBox.
 * @typedef WS.WhiteBox
 * @see http://dev.development.whitespacers.com/libs/docs/whitespace_js_whitebox/
 */

 /**
 * An instance of either WS.Gat (universal or standard).
 * @typedef WS.Gat
 * @see http://dev.development.whitespacers.com/libs/docs/whitespace_js_gat-universal/
 */

 /**
 * The global jQuery object.
 * @typedef {Object} jQuery
 */
(function($, $win, $doc, WS, ob_set) {
	// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
	if (!Object.keys) {
		Object.keys = (function() {
			'use strict';

			var hasOwnProperty = Object.prototype.hasOwnProperty,
					hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
					dontEnums = [
						'toString',
						'toLocaleString',
						'valueOf',
						'hasOwnProperty',
						'isPrototypeOf',
						'propertyIsEnumerable',
						'constructor'
					],
					dontEnumsLength = dontEnums.length;

			return function(obj) {
				if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
					throw new TypeError('Object.keys called on non-object');
				}

				var result = [], prop, i;

				for (prop in obj) {
					if (hasOwnProperty.call(obj, prop)) {
						result.push(prop);
					}
				}

				if (hasDontEnumBug) {
					for (i = 0; i < dontEnumsLength; i++) {
						if (hasOwnProperty.call(obj, dontEnums[i])) {
							result.push(dontEnums[i]);
						}
					}
				}
				return result;
			};
		}());
	}

	/**
	 * @namespace WS
	 */
	if (typeof WS === "undefined") {
		throw new Error("Whitespace utility namespace does not exist");
	}

	/**
	 * @typedef {Object} WS.Access.Options
	 * @property {Object} elements
	 * @property {jQuery} elements.search_field - A jQuery object containing a single search field.
	 * This element will be focused when "Search site" is selected from the WS.Access toolbar.
	 * @property {Object} highlight_hud
	 * @property {Number} highlight_hud.border_width='5' - Define the border width of the highlight
	 * hud that follows the cursor around.
	 * @property {Object} modifiers
	 * @property {Object} modifiers.stick
	 * @property {Number} modifiers.stick.duration='4' - Number of seconds to elapse before multiple
	 * presses of the same key are ignored as a 'sticky' press.
	 * @property {Object} modifiers.shift
	 * @property {Number} modifiers.shift.stick_act_count='3' - Number of times the 'Shift' key must
	 * be pressed before it can be used as a sticky modifier.
	 */

	/**
	 * @class
	 * @arg {WS.Access.Options} options
	 * @arg {WS.WhiteBox} [wb] An instance of WS.WhiteBox
	 * @arg {WS.Gat} [gat] An instance of WS.Gat
	 */
	WS.Access = function(options, wb, gat) {
		var my, cls;

		cls = {
			/**
			 * Enable or disable WS.Acccess
			 * @function WS.Access#enabled
			 * @arg {Boolean} enabled - `true` to enable, `false` to disable.
			 */
			enable: function(enabled) {
				my.status.enabled = (enabled === true);

				if (my.gui.toolbar) {
					if (my.status.enabled) {
						my.gui.toolbar.addClass("enabled");
						my.gui.toolbar.removeClass("disabled");
					} else {
						my.gui.toolbar.removeClass("enabled");
						my.gui.toolbar.addClass("disabled");
					}
				}
			},

			activate: function() {
				my.activate.apply(cls, arguments);
			},

			focus: function() {
				my.focus.apply(cls, arguments);
			},

			contrast: function() {
				my.contrast.activate.apply(cls, arguments);
			},

			highlight: function() {
				my.highlight.activate.apply(cls, arguments);
			},

			search: function() {
				my.search.select.apply(cls, arguments);
			},

			zoom: function() {
				my.zoom.activate.apply(cls, arguments);
			},

			readahead: function() {
				return my.readahead.activate.apply(cls, arguments);
			}
		};

		my = {
			// modifier codes to name map
			modifiers: {
				'18': 'alt',
				'17': 'ctrl',
				'91': 'cmd',
				'16': 'shift'
			},

			// modifiers currently active (pressed)
			active_modifiers: {},

			modifier_stick_count: {},

			// key codes to name map
			keys: {
				'27': 'escape',
				'13': 'enter',
				'65': 'a',
				'67': 'c',
				'72': 'h',
				'82': 'r',
				'83': 's',
				'90': 'z'
			},

			// key names to code map
			codes: {
				'escape': 27,
				'enter': 13,
				'a': 65,
				'c': 67,
				'h': 72,
				'r': 82,
				's': 83,
				'z': 90
			},

			// mutually exclusive toolbar buttons
			mutex: {
				'zoom': ['readahead', 'highlight', 'search'],
				'readahead': ['zoom', 'search']
			},

			// tags excluded from key events
			exclude_key_tags: [
				'input',
				'select',
				'textarea'
			],

			// status controller object
			status: {
				'contrast': false,
				'storage': false,
				'zoom': false,
				'readahead': false,
				'mutex': []
			},

			// class names
			classes: {
				'gui': 'ws-access-gui',
				'dialog': 'ws-access-dialog',
				'keyboard': 'keyboard-key',
				'highlight': 'keyboard-key-highlight',
				'zoom': 'ws-zoomsize-increase'
			},

			enable: function() {
				var activated, modifier;

				// init options
				options = ob_set(options || {}, {
					'elements': {
						'search_field': null
					},
					'highlight_hud': {
						'border_width': 5
					},
					'modifiers': {
						'stick': {
							'duration': 2
						},
						'shift': {
							'stick_act_count': 3
						}
					}
				});

				// internal elements
				my.gui = {
					'labels': {},
					'tips': $(),
					'css': {},
					'popups': {
						'welcome': {
							'header': 'Extended Accessibility Enabled',
							'content': [
								'This website now supports extra functions for enhanced accessibility. A toolbar at the top of this window will provide you with features and options to improve usability.',
								'You can press [Esc] to cancel most functions, or to close dialogs such as this one.',
								'Press [Alt]-[A] to focus the toolbar at any time.',
								'Press [Shift] ' + options.modifiers.shift.stick_act_count + ' times, and then [A] to close the toolbar.',
								'Press [Enter] or click this dialog to close this message.'
							]
						},
						'readahead': {
							'header': 'ReadAhead Advance Reader',
							'content': [
								'The ReadAhead feature will show the content from any standard link on the page in a window, giving you a small and readable preview of the content on that page.',
								'If you decide to read the whole page, you can press {Enter} or click the dialog to visit the page.',
								'Any links clicked while ReadAhead is enabled will display using a preview. Click the &lsquo;ReadAhead&rsquo; toolbar button again to disable.',
								'Press [Enter] or click this dialog to close this message.'
							]
						},
						'outline': {
							'content': [
								'Press [Enter] or click this dialog to read the full page or [Esc] to close.'
							]
						}
					}
				};

				// external DOM elements
				my.elements = {};

				// effects, running or otherwise
				my.effects = {};

				// running timers
				my.timers = {
					'keys': {},
					'ui': {}
				};

				// populate modifier counts with valid codes
				for (modifier in WS.Access.modifiers) {
					if (WS.Access.modifiers.hasOwnProperty(modifier)) {
						my.modifier_stick_count[WS.Access.modifiers[modifier]] = 0;
					}
				}

				// check whitebox is valid, if supplied
				if (wb) {
					if (typeof wb.load === "undefined") {
						throw new Error("The defined WS.WhiteBox class instance is invalid.");
					} else {
						// add event handlers to whitebox
						wb.overlay.bind("overlay:shown", function(event) {
							var overlay = $(this), anchor;

							cls.enable(false);
							my.status.overlay = true;

							if ((anchor = overlay.find("a." + my.classes.dialog)).length) {
								anchor.focus();
							}
						}).bind("overlay:hidden", function() {
							cls.enable(true);
							my.status.overlay = false;
						});
					}
				}

				// check gat is valid, if supplied
				if (gat && typeof gat.track === "undefined") {
					throw new Error("The defined WSGat class instance is invalid.");
				}

				// check for storage
				if (WS.Storage) {
					my.status.messages = window.WS.Storage.get("ws-messages", {});
					activated = window.WS.Storage.get("ws-access-enabled", false);
				}

				my.elements.access_links = $("a[accesskey]");
				my.elements.keys = {};

				// get keyboard key elements on the page for highlighting
				$("span." + my.classes.keyboard).each(function() {
					var el = $(this), label;

					label = el.text();
					label = label.toLowerCase();

					if (!my.elements.keys[label]) {
						my.elements.keys[label] = $();
					}

					my.elements.keys[label] = my.elements.keys[label].add(el);
				});

				$doc.on("focus blur", "a[title], area[title]", my.eventRegister("focus"));

				my.num_access_labels = Object.keys(my.elements.keys).length;

				$win.bind("keyup keydown", my.eventRegister("key"))
					.bind("resize", my.eventRegister("resize"));

				my.access_css('static', true);

				my.status.enabled = true;
				my.status.active = false;

				if (activated) {
					cls.activate(true);
				}
			},

			activate: function(active) {
				if (active === true) {
					// activate - append website into a shim
					if (gat) {
						gat.track_event("WS.Access", "Activate");
					}

					if (!my.gui.shim) {
						my.gui.shim = $("<div>", {
							'id': 'ws-access-shim',
							'class': my.classes.gui
						});

						$doc.children().each(function() {
							my.gui.shim.append($(this));
						});

						$doc.append(
							my.gui.shim
						);

						my.gui.shim.bind(
							"click", my.event
						);
					}

					if (!my.gui.sandbox) {
						$doc.append(
							my.gui.sandbox = $("<div>", {
								'id': 'ws-access-sandbox',
								'class': my.classes.gui + ' ' + my.classes.dialog
							}).css({
								'position': 'absolute',
								'visibility': 'hidden',
								'zIndex': 0
							})
						);
					}

					// set active state
					my.status.active = true;
					my.access_css("active", true);

					if (WS.Storage) {
						window.WS.Storage.set("ws-access-enabled", true, false);

						if (!my.status.messages.welcome) {
							my.popup(my.gui.popups.welcome);
							my.message_set("welcome");
						}
					}

					my.create_gui(true);
					my.resize();
				} else {
					// deactivate
					my.status.active = false;
					my.create_gui(false);
					my.access_css("active", false);

					if (WS.Storage) {
						window.WS.Storage.clear("ws-access-enabled");
					}

					my.gui.shim.css({
						'padding-top': 0
					});

					my.popup();

					// disable any active enhancements
					cls.contrast(false);
					cls.highlight(false);
					my.tooltip();
				}
			},

			eventRegister: function(id) {
				return function(event) {
					my.event.apply(this, [event, id]);
				};
			},

			event: function(event, id) {
				var active, status_change, reset_modifier_stick, element,
					modifier, modifiers;

				switch (event.type) {
					case "keyup":
						if (my.num_access_labels > 0) {
							my.label_highlight(event.keyCode);
						}

						switch (event.keyCode) {
							case WS.Access.modifiers.ALT: // alt
							case WS.Access.modifiers.CTRL: // ctrl
							case WS.Access.modifiers.SHIFT: // shift
							case WS.Access.modifiers.CMD: // command
								my.active_modifiers[event.keyCode] = false;

								// plus 1 to stick count for the pressed modifier
								my.modifier_stick_count[event.keyCode] += 1;

								// set timer to clear the pressed modifier
								my.key_stick_reset(event.keyCode);

								return;
						}

						break;

					case "keydown":
						if (my.num_access_labels > 0) {
							my.label_highlight(event.keyCode, (true));
						}

						//get modifier, outside actions
						switch (event.keyCode) {
							case WS.Access.modifiers.ALT: // alt
							case WS.Access.modifiers.CTRL: // ctrl
							case WS.Access.modifiers.SHIFT: // shift
							case WS.Access.modifiers.CMD: // command
								my.active_modifiers[event.keyCode] = true;
								return;

							case my.codes.escape:
								if (my.status.active) {
									if (wb && wb.active) {
										wb.hide();
									}

									if (my.status.readahead) {
										cls.readahead(false);
									}

									if (my.status.zoom) {
										cls.zoom(false);
									}

									my.tooltip();
								}

								break;
						}

						if (my.key_check(event)) {
							modifiers = false;

							for (modifier in my.active_modifiers) {
								if (my.active_modifiers.hasOwnProperty(modifier)) {
									if (my.active_modifiers[modifier] === true) {
										modifiers = true;
										break;
									}
								}
							}

							switch (event.keyCode) {
								case my.codes.a:
									// activate accessbility additions
									if (my.modifier_stick_count[WS.Access.modifiers.SHIFT] >= options.modifiers.shift.stick_act_count) {
										event.preventDefault();
										active = !my.status.active;
										status_change = true;
										reset_modifier_stick = true;
									} else if (my.active_modifiers[WS.Access.modifiers.ALT] && my.status.active) {
										event.preventDefault();
										reset_modifier_stick = true;
										cls.focus();
									} else {
										return;
									}

									break;

								case my.codes.c:
									// high contrast mode
									if (my.status.active && !modifiers) {
										event.preventDefault();
										cls.contrast();
									}

									reset_modifier_stick = true;

									break;

								case my.codes.h:
									if (my.status.active) {
										event.preventDefault();

										if (my.active_modifiers[WS.Access.modifiers.ALT]) {
											// show welcome popup
											my.popup(my.gui.popups.welcome);
										} else if (!modifiers) {
											// highlight
											cls.highlight();
										}
									}

									reset_modifier_stick = true;

									break;

								case my.codes.s:
									// search field
									if (my.status.active && my.active_modifiers[WS.Access.modifiers.ALT]) {
										event.preventDefault();
										my.search.select();
									}

									reset_modifier_stick = true;

									break;

								case my.codes.z:
									// zoom portion of the page
									if (my.status.active && !modifiers) {
										event.preventDefault();
										cls.zoom();
									}

									reset_modifier_stick = true;

									break;

								case my.codes.r:
									// activate readahead
									if (my.status.active && !modifiers) {
										event.preventDefault();
										cls.readahead();
									}

									reset_modifier_stick = true;

									break;

								default:
									reset_modifier_stick = true;
							}
						}

						// post key work
						if (event.type === "keydown") {
							if (status_change) {
								cls.activate(active);
							}

							if (reset_modifier_stick) {
								// clear timers for all sticky modifiers
								my.key_stick_reset_all();
							}
						}

						break;

					case "resize":
						if (my.status.active) {
							my.resize();
						}
						break;

					case "click":
						if (my.status.active) {
							element = $(event.target).closest("a");

							if (my.status.readahead) {
								if (element.length &&
									(!element.closest("#access-toolbar").length &&
										!element.hasClass(my.classes.dialog))) {
									if (element[0].tagName === "A" &&
										(element.attr("href") !== "#" && element[0].hostname === location.hostname)) {
										event.preventDefault();
										my.tooltip();
										my.fetch_content(element.attr("href"), true, true);
									}
								}
							}

							if (my.status.zoom && my.zoom.hud_element) {
								event.preventDefault();
								my.zoom.ctrl();
							}
						}

						break;

					case "focusin":
						my.element_post_focus($(this), "focus");
						break;

					case "focusout":
						my.element_post_focus($(this), "blur");
						break;

					default:
						return;
				}

				return;
			},

			focus: function() {
				my.gui.toolbar.find("a").first().focus();
			},

			key_check: function(event) {
				var element = $(event.target);

				if (my.status.overlay ||
					(my.exclude_key_tags.indexOf(element[0].tagName.toLowerCase()) !== -1 &&
						!(my.active_modifiers[WS.Access.modifiers.ALT]))) {
					return false;
				} else {
					return true;
				}
			},

			key_stick_reset_all: function() {
				var keycode;

				for (keycode in my.timers.keys) {
					my.key_stick_reset(keycode, true);
				}
			},

			key_stick_reset: function(keycode, confirm) {
				if (!confirm) {
					if (my.timers.keys[keycode]) {
						window.clearTimeout(my.timers.keys[keycode]);
					}

					my.timers.keys[keycode] = window.setTimeout(function() {
						my.key_stick_reset(keycode, true);
					}, (options.modifiers.stick.duration * 1000));
				} else {
					my.modifier_stick_count[keycode] = 0;
					window.clearTimeout(my.timers.keys[keycode]);
					delete my.timers.keys[keycode];
				}
			},

			resize: function() {
				// handle document resizing
				if (my.status.active) {
					my.gui.shim.css({
						'paddingTop': my.gui.toolbar.outerHeight() + 'px'
					});

					if (my.status.zoom) {
						// cancel out zooming
						cls.zoom(false);
					}
				}
			},

			call: function(fn) {
				// call the passed toolbar function with arguments
				if (my.status.enabled) {
					var args = Array.prototype.slice.call(arguments);

					args.shift();

					return fn.apply(cls, args);
				} else {
					return false;
				}
			},

			set_mutex: function(key) {
				// ensures mutual exclusion beetween toolbar functions
				var a, label;

				my.status.mutex = [];

				if (my.mutex[key]) {
					for (a = 0; a != my.mutex[key].length; a += 1) {
						if (my.gui.labels[my.mutex[key][a]]) {
							my.gui.labels[my.mutex[key][a]].removeClass("enabled").addClass("disabled");
							my.status.mutex.push(my.mutex[key][a]);
						}
					}
				} else {
					for (label in my.gui.labels) {
						if (my.gui.labels.hasOwnProperty(label)) {
							my.gui.labels[label].addClass("enabled").removeClass("disabled");
						}
					}
				}
			},

			label_highlight: function(key, highlight) {
				// highlight accesskey label elements (<span class="keyboard-key">)
				var keys;

				if (!my.status.enabled) {
					return true;
				}

				if (my.modifiers[key] &&
					(keys = my.elements.keys[my.modifiers[key]])) {
					if (highlight) {
						keys.addClass(my.classes.highlight);
					} else {
						// fade lit keys
						keys.removeClass(my.classes.highlight);
					}
				}
			},

			create_gui: function(show) {
				var shortcuts, access_links;

				if (show) {
					if (!my.gui.highlight_hud) {
						// create zooming hud
						my.gui.highlight_hud = $("<div>", {
							'id': 'ws-access-highlight-hud',
							'class': my.classes.gui
						}).css({
							'position': 'absolute',
							'zIndex': '2147483647',
							'borderWidth': options.highlight_hud.border_width + 'px',
							'background': 'rgba(255, 255, 255, 0.3)',
							'pointerEvents': 'none'
						}).hide();
					}

					if (my.gui.highlight_hud.css("pointerEvents") === "none") {
						$doc.append(my.gui.highlight_hud);
					} else {
						delete my.gui.highlight_hud;
					}

					// activate toolbar
					if (!my.gui.toolbar) {
						// create toolbar if not added to DOM
						my.gui.toolbar = $("<div>", {
							'id': 'access-toolbar',
							'class': my.classes.gui + ' enabled'
						}).append(
							$("<div>", {
								'class': my.classes.gui + ' content'
							}).append(
								shortcuts = $("<ul>", {
									'class': 'shortcuts'
								})
							)
						);

						// add buttons derived from accesskey links
						if (my.elements.access_links.length > 0) {
							shortcuts.append(
								access_links = $("<ul>", {
									'class': 'access-links'
								})
							);

							my.elements.access_links.each(function() {
								var link = $(this), text, href, id, container;

								href = link.attr("href");

								id = my.convertToId(href);

								if (id !== "" && (container = $("#" + id)).length) {
									text = link.text();
									text = text.replace(/jump\s?to/i, "&rarr;");

									access_links.append(
										$("<li>", {
											'class': 'content-link'
										}).append(
											$("<a>", {
												'href': link.attr("href")
											}).html(
												'<span class="label">' + text + '</span>'
											).bind("click", function(event) {
												event.preventDefault();
												my.call(my.element_focus, event, container, true);
											})
										)
									);
								}
							});
						}

						// add standard buttons
						shortcuts.append(
							my.gui.labels.contrast = $("<li>", {
								'class': 'enabled'
							}).append(
								$("<a>", {
									'href': '#',
									'title': 'Toggle high contrast mode'
								}).html(
									'<strong>C</strong> <span class="label">High contrast</span>'
								).bind("click", function(event) {
									event.preventDefault();
									my.call(cls.contrast);
								})
							)
						);

						// add readahead link
						if (wb) {
							shortcuts.append(
								my.gui.labels.disable = $("<li>", {
									'class': 'enabled'
								}).append(
									$("<a>", {
										'href': '#',
										'title': 'Display help'
									}).html(
										'<strong>' + my.modifiers[WS.Access.modifiers.ALT] +
											'-H</strong> <span class="label">Help</span>'
									).bind("click", function(event) {
										event.preventDefault();
										my.call(my.popup, my.gui.popups.welcome);
									})
								)
							).append(
								my.gui.labels.readahead = $("<li>", {
									'class': 'enabled'
								}).append(
									$("<a>", {
										'href': '#',
										'title': 'Read linked content before loading it'
									}).html(
										'<strong>R</strong> <span class="label">ReadAhead</span>'
									).bind("click", function(event) {
										event.preventDefault();
										my.call(cls.readahead);
									})
								)
							);
						}

						// add zoom link
						if (my.gui.highlight_hud) {
							shortcuts.append(
								my.gui.labels.zoom = $("<li>", {
									'class': 'enabled'
								}).append(
									$("<a>", {
										'href': '#',
										'title': 'Zoom area'
									}).html(
										'<strong>Z</strong> <span class="label">Zoom area</span>'
									).bind("click", function(event) {
										event.preventDefault();
										my.call(cls.zoom);
									})
								)
							);
						}

						// add search link
						if (options.elements.search_field) {
							shortcuts.append(
								my.gui.labels.search = $("<li>", {
									'class': 'enabled'
								}).append(
									$("<a>", {
										'href': '#',
										'title': 'Select the search text box'
									}).html(
										'<strong>' + my.modifiers[WS.Access.modifiers.ALT] +
											'-S</strong> <span class="label">Search site</span>'
									).bind("click", function(event) {
										event.preventDefault();
										my.call(cls.search);
									})
								)
							);
						}

						if (my.elements.access_links.length > 0) {
							shortcuts.append(
								my.gui.labels.highlight = $("<li>", {
									'class': 'enabled'
								}).append(
									$("<a>", {
										'href': '#',
										'title': 'Toggle highlighting of content areas'
									}).html(
										'<strong>H</strong> <span class="label">Highlight Areas</span>'
									).bind("click", function(event) {
										event.preventDefault();
										my.call(cls.highlight);
									})
								)
							);
						}

						// add tooltip
						$doc.append(
							my.gui.tooltip = $("<div>", {
								'id': 'ws-access-tooltip'
							}).css({
								'position': 'absolute',
								'visibility': 'hidden'
							})
						);
					}

					// (re)append into the top of the document
					$doc.prepend(my.gui.toolbar);

					// (re)set highlight hud
					my.highlight.reset();

					// focus first link
					cls.focus();
				} else {
					if (my.gui.toolbar) {
						my.gui.toolbar.remove();
					}

					if (my.gui.highlight_hud) {
						my.gui.highlight_hud.remove();
					}
				}
			},

			access_css: function(id, enable) {
				var css_str, css, a;

				if (!WS.Access.css[id]) {
					return;
				} else {
					css = WS.Access.css[id];
				}

				if (css !== undefined && css !== null) {
					if (enable && !my.gui.css[id]) {
						$("head").append(
							my.gui.css[id] = $("<style>", {
								'type': 'text/css',
								'media': 'screen, projection'
							})
						);

						if (my.gui.css[id][0].styleSheet) {
							css_str = "";

							for (a = 0; a != css.length; a += 1) {
								css_str = css_str + css[a] + " ";
							}

							my.gui.css[id][0].styleSheet.cssText = css_str;
						} else if (my.gui.css[id][0].sheet) {
							for (a = 0; a != css.length; a += 1) {
								my.gui.css[id][0].sheet.insertRule(css[a], 0);
							}
						}
					} else if (!enable) {
						if (my.gui.css[id]) {
							my.gui.css[id].remove();
							delete my.gui.css[id];
						}
					}
				}
			},

			element_focus: function(event, element, find_link) {
				// focuses an element

				if (typeof Effect !== "undefined") {
					if (event && "preventDefault" in event) {
						event.preventDefault();
					}

					new Effect.ScrollTo(element, {
						'offset': -my.gui.toolbar.offsetHeight,
						'duration': 0.5,
						'afterFinish': function() {
							var links;

							if (find_link) {
								// find the first link and focus it
								links = element.select("a[href]", "area[href]");

								if (links.length > 0 && my.element_within_vp(links[0])) {
									links[0].focus();
								}
							}

							new Effect.Highlight(element, {
								'duration': 0.4
							});

							if (element.hasAttribute("tabindex")) {
								element.focus();
							}
						}
					});
				}
			},

			element_post_focus: function(element, type) {
				// acts on an element after it has been focused or blurred
				var title;

				if (type === "focus") {
					// focus
					if (my.status.active) {
						if (my.status.readahead) {
							my.readahead.target(null, element);
						} else {
							title = element.attr("title");

							if (typeof title === "string" && title.length > 0) {
								title = "&ldquo;<i>" + title + "</i>&rdquo;";
								my.tooltip(element, title);
							}
						}
					}
				} else {
					// unfocus
					my.tooltip(element);
				}
			},

			element_within_vp: function(element) {
				// detect whether the element is within the viewport
				var offset, element_offset, vp;

				offset = $doc.viewport.getScrollOffsets();
				vp = $doc.viewport.outerHeight();
				offset.bottom = offset.top + vp;

				element_offset = element.offset();
				element_offset[2] = element_offset[1] + element.outerHeight();

				return (
					(element_offset[1] > offset.top && element_offset[1] < offset.bottom) ||
					(element_offset[1] <= offset.top && element_offset[2] >= offset.bottom) ||
					(element_offset[2] > offset.top && element_offset[2] < offset.bottom)
				);
			},

			tooltip: function(element, text) {
				// produces a tooltip next to the specified element
				var element_pos;

				if (element !== undefined && typeof text === "string") {
					// produce tooltip
					my.gui.tooltip.html(text);

					element_pos = element.offset();

					my.gui.tooltip.css({
						'visibility': 'visible',
						'top': (element_pos.top - my.gui.tooltip.outerHeight()) - (2) + 'px',
						'left': element_pos.top + 'px'
					});
				} else {
					// clear tooltip (hide)
					my.gui.tooltip.css({
						'visibility': 'hidden'
					});
				}
			},

			search: {
				select: function() {
					// selects the defined search field
					var field;

					if (my.status.mutex.indexOf("search") === -1 &&
						(field = options.elements.search_field).length) {
						field.focus();
						my.highlight.target(null, field.closest("form"), 2);
					}
				}
			},

			readahead: {
				activate: function(activate) {
					if (my.status.mutex.indexOf("readahead") === -1) {
						if (activate === undefined) {
							my.status.readahead = !(my.status.readahead);
						} else {
							my.status.readahead = activate;
						}

						if (my.status.readahead) {
							my.set_mutex("readahead");
							my.gui.labels.readahead.addClass("active");

							if (!my.status.messages.readahead) {
								my.popup(my.gui.popups.readahead);
								my.message_set("readahead");
							}

							$win.bind("mousemove", my.readahead.target);
						} else {
							my.set_mutex();
							my.gui.labels.readahead.removeClass("active");

							$win.unbind("mousemove", my.readahead.target);

							my.tooltip();
						}
					}
				},

				target: function(event, element) {
					var text, title, href;

					if (!element && event) {
						element = $(event.target).closest("a");
					}

					if (!wb.active &&
						element.length &&
						(!element.closest("access-toolbar").length)) {
						href = element.attr("href");
						title = element.attr("title");

						if (href !== "#" && element[0].hostname === location.hostname) {
							text = "<strong>ReadAhead This Link</strong>";

							if (title !== null && title !== "") {
								text += "</br>&ldquo;<i>" + title + "</i>&rdquo;";
							}

							if (href === "/") {
								text += "</br>" + element[0].hostname;
							} else {
								text += "</br>" + href;
							}

							my.tooltip(
								element,
								text
							);
						}
					} else {
						my.tooltip();
					}
				}
			},

			zoom: {
				activate: function(activate) {
					if (my.gui.highlight_hud && my.status.mutex.indexOf("zoom") === -1) {
						if (activate === undefined) {
							my.status.zoom = !(my.status.zoom);
						} else {
							my.status.zoom = activate;
						}

						if (my.status.zoom) {
							my.set_mutex("zoom");
							my.gui.labels.zoom.addClass("active");

							$win.bind("mousemove", my.highlight.target);
						} else {
							my.set_mutex();
							my.gui.labels.zoom.removeClass("active");

							$win.unbind("mousemove", my.highlight.target);

							my.highlight.reset();
						}
					}
				},

				ctrl: function() {
					// zoom in (increase the text size of) the area selected by the zoom hud
					if (!my.status.zoom) {
						return false;
					}

					if (my.zoom.element) {
						// zoom out element
						my.zoom.element.removeClass(my.classes.zoom);

						if (my.zoom.element === my.zoom.hud_element) {
							// hud element is the same, stop zoom in
							delete my.zoom.hud_element;
						}
					}

					if (my.zoom.hud_element) {
						// zoom in element
						my.zoom.hud_element.addClass(my.classes.zoom);

						my.zoom.element = my.zoom.hud_element;
					}

					// stop zoom
					cls.zoom(false);
				}
			},

			contrast: {
				activate: function(enable) {
					if (my.status.contrast || enable === false) {
						// disable
						my.status.contrast = false;

						$doc.removeClass("high-contrast");
						my.gui.labels.contrast.removeClass("active");

						my.access_css("contrast", false);
					} else {
						// enable
						my.status.contrast = true;

						$doc.addClass("high-contrast");
						my.gui.labels.contrast.addClass("active");

						my.access_css("contrast", true);
					}
				}
			},

			highlight: {
				activate: function(enable) {
					var header_text, element, accesskey;

					if (my.elements.access_links.length === 0 ||
						my.status.mutex.indexOf("highlight") !== -1) {
						return false;
					}

					if (my.status.highlight || enable === false) {
						// disable
						my.gui.tips.hide();

						my.status.highlight = false;
						my.gui.labels.highlight.removeClass("active");
					} else {
						// enable
						if (my.gui.tips.length === 0) {
							// create and show tips
							my.elements.access_links.each(function() {
								var link = $(this), href, id, tip, header;

								href = link.attr("href");
								accesskey = link.attr("accesskey");
								id = my.convertToId(href);
								element = $("#" + id);

								if (accesskey !== null && element !== null) {
									header = element.find("h1").first();

									tip = $("<div>", {
										'class': 'access-tip'
									}).append(
										$("<span>", {
											'class': 'id'
										}).html(id)
									).append(
										$("<span>", {
											'class': 'accesskey'
										}).html("Access key <strong>" + accesskey + "</strong>")
									);

									if (header) {
										header_text = header.html();
										tip.append(
											$("<span>", {
												'class': 'title'
											}).html(header_text)
										);
									}

									element.prepend(tip);

									my.gui.tips = my.gui.tips.add(tip);
								}
							});
						} else {
							// show tips
							my.gui.tips.show();
						}

						my.status.highlight = true;
						my.gui.labels.highlight.addClass("active");
					}
				},

				target: function(event, target, remove_after) {
					// switch the highlight hud to the specified target
					var pos, dimensions;

					if (!my.gui.highlight_hud) {
						return false;
					}

					if (target === undefined) {
						target = $(event.target);

						if (target && target[0].tagName !== "DIV") {
							target = target.closest("div:not(." + my.classes.gui + ")");
						}
					}

					if (target.length &&
						(my.zoom.hud_element || !my.zoom.hud_element) &&
						!target.hasClass(my.classes.gui)) {
						// switch target
						pos = target.offset();

						my.gui.highlight_hud.show().css({
							'left': (pos.left - options.highlight_hud.border_width) + 'px',
							'top': (pos.top - options.highlight_hud.border_width) + 'px',
							'width': target.outerWidth() + 'px',
							'height': target.outerHeight() + 'px'
						});

						my.zoom.hud_element = target;

						if (remove_after !== undefined && !isNaN(remove_after)) {
							if (my.timers.ui.highlight) {
								clearTimeout(my.timers.ui.highlight);
								delete my.timers.ui.highlight;
							}

							my.timers.ui.highlight = setTimeout(function() {
								my.gui.highlight_hud.stop().animate({
									'opacity': 0
								}, 300, 'swing', function() {
									my.highlight.reset();
								});
							}, (remove_after * 1000));
						}
					}
				},

				reset: function() {
					// park the highlight hud under the toolbar
					var metrics, height, pos;

					if (my.gui.highlight_hud) {
						my.gui.highlight_hud.hide().css({
							'opacity': 1
						});

						pos = my.gui.toolbar.offset();
						height = my.gui.toolbar.outerHeight();

						my.gui.highlight_hud.css({
							'left': pos.left + 'px',
							'top': pos.top + 'px',
							'width': '100%',
							'height': height + 'px'
						});
					}
				}
			},

			fetch_content: function(url, outline, limit) {
				// fetches content and puts it into a whitebox
				var content, nodes;

				$.ajax(url, {
					'complete': function(response) {
						var a, text, html;

						if (outline) {
							// get rid of everything except the outline
							content = $("<div>");
							content[0].innerHTML = response.responseText;

							if (limit === true) {
								// set limit to 90% of shim height
								limit = Math.round(($win.height() - my.gui.toolbar.outerHeight()) * 0.8);
							}

							nodes = content.find("h1, h2, h3, p").slice(0, limit - 1);
							my.gui.sandbox.html("");

							nodes.each(function() {
								var $this = $(this);

								if ((limit && my.gui.sandbox.height() <= limit) || !limit) {
									text = $this.text();

									if (text !== undefined && text.length > 0) {
										my.gui.sandbox.append(
											$("<span>", {
												'class': $this[0].tagName.toLowerCase()
											}).html(text)
										);
									}
								} else {
									return false;
								}
							});

							for (a = 0; a < my.gui.popups.outline.content.length; a += 1) {
								my.gui.sandbox.append(
									$("<span>", {
										'class': 'p'
									}).html(my.parse_dialog_content(my.gui.popups.outline.content[a]))
								);
							}

							html = my.gui.sandbox[0].innerHTML;

							my.popup(html, {
								'id': 'ws-access-outline',
								'href': url
							});
						} else {
							html = my.gui.sandbox[0].innerHTML;
							my.popup(html);
						}
					}
				});
			},

			popup: function(data, options) {
				// produce welcome message
				var dialog, a, content;

				options = ob_set(options || {}, {
					'id': null
				});

				if (wb) {
					if (data !== undefined) {
						if (typeof data === "string") {
							dialog = $("<a>", {
								'class': my.classes.dialog
							}).append(data);

							if (options.rel) {
								dialog.attr("rel", options.rel);
							}

							if (options.href) {
								dialog.attr("href", options.href);
							}

							if (options.id) {
								dialog.id = options.id;
							}
						} else {
							dialog = $("<a>", {
								'class': my.classes.dialog,
								'href': '#'
							}).append(
								$("<span>", {
									'class': 'h2'
								}).append(data.header)
							).bind("click", function(event) {
								event.preventDefault();
								wb.hide();
							});

							for (a = 0; a !== data.content.length; a += 1) {
								content = my.parse_dialog_content(data.content[a]);

								dialog.append(
									$("<span>", {
										'class': 'p'
									}).html(content)
								);
							}
						}

						wb.load("inline", {
							'element': dialog
						}, {
							'show': {
								'modal': true
							}
						});
					} else {
						// close (if opened by WS.Access)
						if (wb.overlay.find("a." + my.classes.dialog).length) {
							wb.hide();
						}
					}
				}
			},

			message_set: function(key) {
				my.status.messages[key] = true;

				if (WS.Storage) {
					window.WS.Storage.set("ws-messages", my.status.messages);
				}
			},

			parse_dialog_content: function(string) {
				string = string.replace(
					/\[([^\]]+)\]/g,
					'<span class="' + my.classes.keyboard + '">$1</span>'
				);

				return string;
			},

			convertToId: function(string) {
				return string
					.replace(/^#?\d*/g, "")
					.replace(/[^a-zA-Z0-9-]/g, "");
			}
		};

		WS.Access.modifiers = {
			'ALT': 18,
			'CTRL': 17,
			'SHIFT': 16,
			'CMD': 91
		};

		WS.Access.css = {
			'static': [
				'#ws-access-shim { margin: 0; padding: 0; overflow: hidden; }',
				'#access-toolbar { position: fixed; z-index: 99990; left: 0; top: 0; border-bottom: 1px solid #eee; width: 100%; font-family: sans-serif; letter-spacing: 0; background: #eee; }',
				'#access-toolbar div.content { overflow: hidden; border-bottom: 1px solid #999; padding: 0 5px; color: #000; }',
				'#access-toolbar p { margin: 0; color: #000; }',
				'#access-toolbar ul { float: left; list-style: none; padding: 5px 0 5px 5px; margin: 0; }',
				'#access-toolbar ul ul { padding: 0; }',
				'#access-toolbar ul li { float: left; margin: 2px 5px 2px 0; padding: 0; font-size: .875em; }',
				'#access-toolbar ul a { float: left; -webkit-transition: all .3s; -moz-transition: all .3s; transition: all .3s; -webkit-border-radius: 5px; -moz-border-radius: 5px; border-radius: 5px; border: 1px solid #fff; padding: 2px 6px; text-decoration: none; color: #000; background: #fff; white-space: nowrap; }',
				'#access-toolbar.disabled ul li a, #access-toolbar ul li.disabled a { color: #fff; background: #eee; border-color: #eee; cursor: default; }',
				'#access-toolbar ul li.content-link a { border: 1px outset #eee; background-color: #d5ddff; }',
				'#access-toolbar.enabled ul li.active a, #access-toolbar.enabled ul.shortcuts li.enabled a:hover, #access-toolbar.enabled ul.shortcuts li.enabled a:focus, #access-toolbar.enabled ul.shortcuts li.enabled a:active { color: #000; background: #ECE964; }',
				'#access-toolbar ul li a span, #access-toolbar ul.shortcuts li a strong { color: #000; }',
				'#access-toolbar.disabled ul li a span, #access-toolbar ul li.disabled a span, #access-toolbar.disabled ul.shortcuts li a strong, #access-toolbar ul.shortcuts li.disabled a strong { color: #ccc; }',
				'#access-toolbar ul strong, div.access-tip span.accesskey strong { font-family: "Courier New", "Courier", "Fixedsys", Monospace; }',
				'div.access-tip { position: relative; overflow: hidden; z-index: 99989; -webkit-border-radius: 5px 5px 0 0; -moz-border-radius: 5px 5px 0 0; border-radius: 5px 5px 0 0; font-size: 16px; background: #ECE964; }',
				'div.access-tip span { float: left; display: inline; margin-right: 5px; padding: 4px 6px; font: 1em Sans-serif; letter-spacing: 0; color: #000; }',
				'div.access-tip span.id { -webkit-border-radius: 5px 0 0 0; -moz-border-radius: 5px 0 0 0; border-radius: 5px 0 0 0; color: #000; background: #86DAEC; }',
				'div.access-tip span.title { font-style: italic; color: #3A3A3A; }',
				'#ws-access-tooltip { z-index: 99991; border: 2px solid #333; -webkit-border-radius: 3px; -moz-border-radius: 3px; border-radius: 3px; padding: 5px; font: 11px Sans-serif; color: #000; background-color: #ECE964; }',
				'#ws-access-highlight-hud, .ws-access-dialog { border-style: solid; border-color: rgba(236, 227, 63, 0.8); -webkit-border-radius: 6px; -moz-border-radius: 6px; -o-border-radius: 6px; border-radius: 6px; cursor: pointer !important; }',
				'#ws-access-highlight-hud { -webkit-transition-property: width, height, left, top; -webkit-transition-duration: 0.2s; -moz-transition-property: width, height, left, top; -moz-transition-duration: 0.2s; transition-property: width, height, left, top; transition-duration: 0.2s; }',
				'#ws-access-outline { width: 500px; }',
				'.ws-access-dialog, a.ws-access-dialog { display: block; width: 450px; padding: 10px; line-height: 130%; font-family: Helvetica, Arial, sans-serif; text-decoration: none !important; background: #fff; }',
				'.ws-access-dialog span.h1 { display: block; margin: 10px 0; font-size: 26px; }',
				'.ws-access-dialog span.h2 { display: block; margin: 10px 0; font-size: 24px; }',
				'.ws-access-dialog span.h3 { display: block; margin: 10px 0; font-size: 20px; }',
				'.ws-access-dialog span.p { display: block; margin: 10px 0; font-size: 16px; }',
				'span.keyboard-key { display: inline-block; border-top: 1px solid #eee; border-right: 1px solid #666; border-bottom: 1px solid #666; border-left: 1px solid #eee; padding: 1px 2px; background-color: #ccc; color: #333; font: .9em Courier, Monospace, Fixed; }',
				'span.keyboard-key-highlight { background-color: #FFF846 !important; }'
			],
			'active': [
				'div#ws-access-shim a:focus, div#ws-access-shim a:active, div#ws-access-shim area:focus, div#ws-access-shim area:active { position: relative; z-index: 99999; outline: 2px solid #000; background: #ECE964 !important; color: #000 !important; }',
				'div#ws-access-shim a:focus *, div#ws-access-shim a:active *, div#ws-access-shim area:focus *, div#ws-access-shim area:active * { color: #000 !important; }',
				'div#ws-access-shim ul#accesslinks { display: none; }',
				'.ws-zoomsize-increase > * { zoom: 1.125; }',
				'#whitebox-bg { background-color: #000; }'
			],
			'contrast': [
				"div#ws-access-shim * { background-color: transparent !important; background-image: none !important; }",
				"div#ws-access-shim h1, div#ws-access-shim h2, div#ws-access-shim h3, div#ws-access-shim h4, div#ws-access-shim h5, div#ws-access-shim h6, div#ws-access-shim p, div#ws-access-shim td, div#ws-access-shim li, div#ws-access-shim span, div#ws-access-shim em, div#ws-access-shim i, div#ws-access-shim strong, div#ws-access-shim b { color: #fff !important; }",
				"body.high-contrast { background: black !important; color: #fff; }",
				"div#ws-access-shim a, div#ws-access-shim area { color: #FAFB14 !important; }",
				"div#ws-access-shim a:hover, body.high-contrast div#ws-access-shim a:focus, body.high-contrast a:active { background: black; color: #fff }",
				"div#ws-access-shim a:visited { color: #96960C !important; }",
				"div#ws-access-shim input, div#ws-access-shim select, div#ws-access-shim textarea { background: #fff !important; color: #000 !important; }"
			]
		};

		my.enable();

		return cls;
	};
}(window.jQuery, window.jQuery(window), window.jQuery(document.body), window.WS, window.ob_set));